<template>
  <div>
    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      summary
      :summary-method="summaryMethod"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="toDetail(scope.data, scope.$index)"
        >明细</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView"></component>
      <span slot="footer">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/procure/plan/components/form'

import { getDropPlantationList } from '@/api/manage/plantation'
import { getSkinList } from '@/api/manage/report'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    const _this = this
    return {
      dialogVisible: false,
      title: '',
      currentView: '',
      authIdentity: 'process:skin',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          width: 140,
          align: 'left',
        },
        {
          prop: 'locDetails',
          width: 280,
          label: '果园区域',
          isTrue: true,
          align: 'left',
          formatter(row) {
            return row.locDetails?.split(',').slice(3).join('')
          },

        },
        {
          prop: 'cropBrandKeyValue',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: 'fertilizerTypeKeyValue',
          label: '施肥种类',
          isTrue: true,
        },
        {
          prop: 'fieldTypeKeyValueList',
          label: '土地性质',
          isTrue: true,
        },
        {
          prop: 'ownerName',
          label: '园主/场长',
          isTrue: true,
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
        },

        {
          prop: 'freshFruitTotalNetWeight',
          label: '鲜果验收总净重(斤)',
          isTrue: true,
          width: 160,
        },
        {
          prop: 'freshPeelTotalNetWeight',
          label: '鲜皮总净重(斤)',
          isTrue: true,
        },
        {
          prop: '',
          label: '鲜皮率(%)',
          isTrue: true,
          formatter(row) {
            return _this.myFixed(row.freshPeelRate, 2)
          }
        },
        {
          prop: 'totalNetWeight',
          label: '干皮总净重(斤)',
          isTrue: true,
          width: 140,
        },
        {
          prop: '',
          label: '出皮率(%)',
          isTrue: true,
          formatter(row) {
            return _this.myFixed(row.peelRate, 2)
          }
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],

      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        // {
        //   model: 'projectId',
        //   placeholder: '请选择进仓年份',
        //   value: 'id',
        //   label: 'projectName',
        //   list: [],
        //   type: 'year',
        // },
      ],
    }
  },
  mounted() {
    this.getPlantationList()
    this.getList()
  },
  methods: {
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getSkinList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getPlantationList() {
      getDropPlantationList().then((res) => {
        this.selectOrInputList[0].list = res.data.map((item) => {
          item.name = `${item.bizNo}-${item.name}`
          return item
        })
      })
    },
    summaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 8) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshFruitTotalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 9) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 10) {
          const freshPeelTotalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0)

          const freshFruitTotalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshFruitTotalNetWeight || 0), 2)
          }, 0)

          sums[index] = !freshFruitTotalNetWeight
            ? freshFruitTotalNetWeight
            : this.myFixed((freshPeelTotalNetWeight / freshFruitTotalNetWeight) * 100, 2)
          return
        }
        if (index == 11) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 12) {
          const totalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)

          const processingFreshNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.processingFreshNetWeight || 0), 2)
          }, 0)

          sums[index] = !processingFreshNetWeight
            ? processingFreshNetWeight
            : this.myFixed((totalNetWeight / processingFreshNetWeight) * 100, 2)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    toDetail({ plantationId, plantationName }) {
      this.$router.push(`/skinDetail?plantationId=${plantationId}&plantationName=${plantationName}`)
    },
    submitFrom() {},
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'myform'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
// @import '../../../../assets/form.less';
@import '~@/assets/tableList.less';
/deep/ .el-button--text {
  font-size: 14px;
}
</style>
